import { useEffect, useLayoutEffect, useState } from 'react'

import { storeLastProduct } from './storeLastProduct'

export interface UseRestorePosition {
	id?: string
}

export function saveSlotId(slotId: string, catalogId: string) {
	localStorage.setItem(`plp-product-${catalogId}`, slotId)
}
export function useRestorePosition(catalogId: string): UseRestorePosition {
	const [pendingScrollSlot, setPendingScrollSlot] = useState<string | null>(
		null
	)

	useEffect(() => {
		setPendingScrollSlot(localStorage.getItem(`plp-product-${catalogId}`))
	}, [])

	useEffect(() => {
		if (!pendingScrollSlot) {
			scrollTo({ top: 0, behavior: 'instant' })
		}
	}, [pendingScrollSlot])

	useLayoutEffect(() => {
		const storeHandler = (e: Event) => {
			const slotId = (e.target as HTMLLIElement).closest('li')?.dataset.slot
			if (slotId) {
				storeLastProduct(slotId, catalogId)
			}
		}
		const serverGridElement = document.querySelector('#grid-container')
		/**
		 * Listening click on server product slots
		 */
		serverGridElement
			?.querySelectorAll('[data-slot]')
			.forEach((slotElement: Element) => {
				slotElement.setAttribute('listening', 'true')
				slotElement.addEventListener('click', storeHandler)
			})

		return () => {
			serverGridElement
				?.querySelectorAll('[data-slot]')
				.forEach((slotElement: Element) => {
					slotElement.removeEventListener('click', storeHandler)
				})
		}
	}, [])

	return {
		id: pendingScrollSlot ?? undefined,
	}
}
